import { type IContent } from "@kunduz/data-access-cms-api";
import { ScrollingBanner } from "@kunduz/ui-components";
import { trackEventNext } from "@kunduz/utility-analytics";
import Link from "next/link";
import React, { PropsWithChildren, ReactElement } from "react";

export const ScrollingBannerWithContext = (props: Props): ReactElement => {
  const handleClick = () => {
    trackEventNext({
      event: "Sliding Banner Clicked",
    });
  };

  const WrapperComponent = props.data.url
    ? ({ children }: PropsWithChildren) => (
        <Link
          href={props.data.url as string}
          target={props.data.target}
          onClick={handleClick}
        >
          {children}
        </Link>
      )
    : ({ children }: PropsWithChildren) => (
        <React.Fragment>{children}</React.Fragment>
      );

  return (
    <WrapperComponent>
      <ScrollingBanner
        theme={props.data.color as any}
        lines={[props.data.first_text, props.data.second_text]}
        divider={
          <img
            style={{ maxWidth: 16, maxHeight: 16 }}
            src={props.data.image}
            alt=""
          />
        }
      />
    </WrapperComponent>
  );
};

interface Props {
  data: IContent.SlidingBannerResponse;
}
